import React from "react";

import ExtraCurricular from "./components/ExtraCurricular";
import eventDatas from "./utils/eventDatas";

import classes from "./index.module.css";

const ExtraCurriculars = () => {
  return (
    <div className={classes["wrapper"]}>
      <h1 className={classes["header"]}>Tadbirlar</h1>
      <div className={classes["container"]}>
        {eventDatas.map((value, index) => {
          return (
            <ExtraCurricular
              key={value.id}
              index={index}
              extraCurricular={value}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExtraCurriculars;
